export default "__VITE_ASSET__eQwm_S2B__"